<template>
  <div>
    <ca-heading text="Opções de Cálculo" />
    <ca-page>
      <ca-loader v-if="showLoading"></ca-loader>
      <ca-form
        v-else
        :key="formKey"
        :on-submit="onSubmit"
        :on-submit-success="onSubmitSuccess"
        :on-submit-error="onSubmitError"
        :error-message="errorMessage">
        <ca-row>
          <ca-col size="6">
            <ca-field label="Adiantamento">
              <ca-checkbox
                v-model="intern.advanceSalary"
                label="Sim"
                @change="refreshForm" />
            </ca-field>
          </ca-col>
          <ca-col size="6">
            <ca-field label="Valor">
              <ca-input-currency
                :key="intern.advanceValue"
                v-model="intern.advanceValue"
                :disabled="!intern.advanceSalary"
                :required="intern.advanceSalary"
                maxlength="10">
              </ca-input-currency>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Forma de Pagamento">
              <ca-select
                v-model="intern.paymentType"
                compare-value-by="name"
                placeholder="Selecione"
                :on-change="refreshForm">
                <ca-option
                  v-for="status in paymentTypeItems"
                  :key="status.name"
                  :value="status">
                  {{ status.description }}
                </ca-option>
              </ca-select>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Banco">
              <ca-select
                v-model="intern.bank"
                compare-value-by="value"
                placeholder="Selecione"
                :on-change="refreshForm">
                <ca-option
                  v-for="status in bankItems"
                  :key="status.value"
                  :value="status">
                  {{ status.description }}
                </ca-option>
              </ca-select>
            </ca-field>
          </ca-col>
          <ca-col size="6">
            <ca-field label="Agência">
              <ca-input
                v-model="intern.branch"
                mask-pattern="99999-9">
              </ca-input>
            </ca-field>
          </ca-col>
          <ca-col size="6">
            <ca-field label="Conta Corrente">
              <ca-input
                v-model="intern.account"
                mask-pattern="999999999999-A">
              </ca-input>
            </ca-field>
          </ca-col>
          <ca-col size="6">
            <ca-field label="Operação">
              <ca-input
                v-model="intern.operation"
                maxlength="4">
              </ca-input>
            </ca-field>
          </ca-col>
        </ca-row>

        <ca-footer>
          <ca-row vertical-offset="2">
            <ca-col size="2">
              <ca-button full-width @click="goBack">
                Voltar
              </ca-button>
            </ca-col>
            <ca-col offset="8" size="2">
              <ca-submit-button>
                Salvar
              </ca-submit-button>
            </ca-col>
          </ca-row>
        </ca-footer>
      </ca-form>
    </ca-page>
  </div>
</template>

<script>
import { getBoxInformationErrorMessage } from 'packages/common/utils';
import { toasterService } from 'packages/common/ds-components';
import { getIntern, editIntern } from './internService';

export default {
  name: 'InternsFormPage',
  data() {
    return {
      formKey: 0,
      internId: this.$route.params.id,
      intern: {},
      errorMessage: null,
      showLoading: false,
    };
  },
  computed: {
    hasInternId() {
      return this.internId;
    },
    bankItems() {
      return this.$store.state.misc.banks;
    },
    paymentTypeItems() {
      return this.$store.state.misc.paymentTypes;
    },
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.$store.dispatch('misc/getPaymentTypes');
      this.$store.dispatch('misc/getBanks');

      if (this.hasInternId) {
        this.setIntern();
      }
    },
    async setIntern() {
      this.showLoading = true;
      try {
        this.intern = await getIntern(this.internId);
      } finally {
        this.showLoading = false;
      }
    },
    goBack() {
      this.$router.back();
    },
    onSubmit() {
      return editIntern(this.internId, this.intern);
    },
    onSubmitSuccess() {
      this.goBack();
      toasterService.success({
        title: 'Sucesso',
        content: 'As informações foram salvas',
      });
    },
    onSubmitError(error) {
      this.errorMessage = getBoxInformationErrorMessage(error);
    },
    refreshForm() {
      this.formKey++;
    },
  },
};
</script>
